'use client'
import { jsx } from "react/jsx-runtime";
import { motion } from "motion/react";
import { cn } from "../../../utils/index.js";
function GlowEffect({ className, colors = [
    '#FF5733',
    '#33FF57',
    '#3357FF',
    '#F1C40F'
], mode = 'rotate', blur = 'medium', transition, scale = 1, duration = 5 }) {
    const BASE_TRANSITION = {
        repeat: 1 / 0,
        duration: duration,
        ease: 'linear'
    };
    const animations = {
        rotate: {
            background: [
                `conic-gradient(from 0deg at 50% 50%, ${colors.join(', ')})`,
                `conic-gradient(from 360deg at 50% 50%, ${colors.join(', ')})`
            ],
            transition: {
                ...transition ?? BASE_TRANSITION
            }
        },
        pulse: {
            background: colors.map((color)=>`radial-gradient(circle at 50% 50%, ${color} 0%, transparent 100%)`),
            scale: [
                +scale,
                1.1 * scale,
                +scale
            ],
            opacity: [
                0.5,
                0.8,
                0.5
            ],
            transition: {
                ...transition ?? {
                    ...BASE_TRANSITION,
                    repeatType: 'mirror'
                }
            }
        },
        breathe: {
            background: [
                ...colors.map((color)=>`radial-gradient(circle at 50% 50%, ${color} 0%, transparent 100%)`)
            ],
            scale: [
                +scale,
                1.05 * scale,
                +scale
            ],
            transition: {
                ...transition ?? {
                    ...BASE_TRANSITION,
                    repeatType: 'mirror'
                }
            }
        },
        colorShift: {
            background: colors.map((color, index)=>{
                const nextColor = colors[(index + 1) % colors.length];
                return `conic-gradient(from 0deg at 50% 50%, ${color} 0%, ${nextColor} 50%, ${color} 100%)`;
            }),
            transition: {
                ...transition ?? {
                    ...BASE_TRANSITION,
                    repeatType: 'mirror'
                }
            }
        },
        flowHorizontal: {
            background: colors.map((color)=>{
                const nextColor = colors[(colors.indexOf(color) + 1) % colors.length];
                return `linear-gradient(to right, ${color}, ${nextColor})`;
            }),
            transition: {
                ...transition ?? {
                    ...BASE_TRANSITION,
                    repeatType: 'mirror'
                }
            }
        },
        static: {
            background: `linear-gradient(to right, ${colors.join(', ')})`
        }
    };
    const getBlurClass = (blur)=>{
        if ('number' == typeof blur) return `blur-[${blur}px]`;
        const presets = {
            softest: 'blur-xs',
            soft: 'blur-sm',
            medium: 'blur-md',
            strong: 'blur-lg',
            stronger: 'blur-xl',
            strongest: 'blur-xl',
            none: 'blur-none'
        };
        return presets[blur];
    };
    return /*#__PURE__*/ jsx(motion.div, {
        style: {
            '--scale': scale,
            willChange: 'transform',
            backfaceVisibility: 'hidden'
        },
        animate: animations[mode],
        className: cn('pointer-events-none absolute inset-0 h-full w-full', 'scale-[var(--scale)] transform-gpu', getBlurClass(blur), className)
    });
}
export { GlowEffect };
